const host =
  import.meta.env.VITE_API_BASE_URL || 'https://test-api.qualify.coimbra.io'

const config = {
  apiBaseUrl: `${host}/api/v1`,
  agentBaseUrl: `${host}/api/agent`,
}

export default config